import Vue from 'vue'
import PostResultNotify from '@/components/PostResultNotify.vue'

/**
 * 提交類接口結果提示（成功 / 失敗），可 await 至用戶關閉。
 * @param {{ type?: 'success'|'error'|'warning'|'info', title?: string, message: string, btnText?: string }} opts
 * @returns {Promise<void>}
 */
export function showPostNotify(opts) {
  const o = opts || {}
  const type = o.type || 'info'
  const message = o.message != null ? String(o.message) : ''
  const title = o.title != null ? String(o.title) : ''
  const btnText = o.btnText != null ? String(o.btnText) : '確定'
  const Constructor = Vue.extend(PostResultNotify)
  const vm = new Constructor({
    propsData: { type, title, message, btnText },
  })
  return new Promise((resolve) => {
    vm.$once('closed', () => {
      vm.$destroy()
      if (vm.$el && vm.$el.parentNode) vm.$el.parentNode.removeChild(vm.$el)
      resolve()
    })
    vm.$mount()
    document.body.appendChild(vm.$el)
  })
}

export default function install(Vue) {
  Vue.prototype.$postNotify = showPostNotify
}
